module.exports = __webpack_public_path__ + "img/spotCheckDone.e528b591.png";